import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'GET_UNIT_MODELS',
	'CREATE_UNIT_MODELS',
	'UPDATE_UNIT_MODELS',
	'DELETE_UNIT_MODELS',
);
